(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React from 'react';
import Container from 'react-bootstrap/Container';
import ScrollToTop from "../components/scroll-to-top";
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Helmet } from "react-helmet";
import { Link } from 'react-router-dom';

class NoMatch extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, "404 Error - The page cannot be found!"), /*#__PURE__*/React.createElement("meta", {
      name: "description",
      content: "Please try again! If you receive this message a second time, please report this problem"
    })), /*#__PURE__*/React.createElement(ScrollToTop, null), /*#__PURE__*/React.createElement(Header, {
      mode: "nobg"
    }), /*#__PURE__*/React.createElement("div", {
      id: "content",
      className: "bypass-block-target",
      tabIndex: "-1"
    }, /*#__PURE__*/React.createElement(Container, {
      className: "content topc"
    }, /*#__PURE__*/React.createElement("h1", {
      className: "h1 mb-5 biglinehd"
    }, /*#__PURE__*/React.createElement("span", null, "The page cannot be found!")), /*#__PURE__*/React.createElement("p", {
      className: "text-center"
    }, /*#__PURE__*/React.createElement("strong", null, "Please try again! \xA0\xA0"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), "If you receive this message a second time,", /*#__PURE__*/React.createElement("br", null), "please report this problem at ", /*#__PURE__*/React.createElement("a", {
      href: "mailto:help@it49.com"
    }, "help@it49.com")))), /*#__PURE__*/React.createElement(Footer, null));
  }

  // @ts-ignore
  __reactstandin__regenerateByEval(key, code) {
    // @ts-ignore
    this[key] = eval(code);
  }

}

const _default = NoMatch;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(NoMatch, "NoMatch", "/var/www/html/websites/thedistrictusc-com/src/frontend/pages/no-match.jsx");
  reactHotLoader.register(_default, "default", "/var/www/html/websites/thedistrictusc-com/src/frontend/pages/no-match.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();